import {
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { MatTableDataSource, MatPaginator, MatTable, MatDialog, MatDialogConfig, MatSnackBar, MatSort } from '@angular/material';
// import moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/component/shared/services/auth.service';
import { HOME_PATH } from '../../shared/others/constant';
import { CommonService } from '../../shared/services/common.service';
// import { PerfectScrollbarComponent, PerfectScrollbarConfigInterface } from 'perfect-scrollbar-angular';
// import { MatTable, MatTableDataSource } from '@angular/material/table';
// import { MatPaginator } from '@angular/material/paginator';
// import { MatSort } from '@angular/material/sort';
// import { MatDialog } from '@angular/material/dialog';
// import { MatSnackBar } from '@angular/material/snack-bar';
// import { MatTableExporterDirective } from 'mat-table-exporter';

@Component({
  selector: 'app-password-expiration',
  templateUrl: './password-expiration.component.html',
  styleUrls: ['./password-expiration.component.scss'],
})
export class PasswordExpirationComponent implements OnInit {
  // constructor(
  //   // private dialog: MatDialog,
  //   // private drvService: DeviceMonitorService,
  //   // private _snackBar: MatSnackBar,
  //   private router: Router,
  //   public authService: AuthService,
  //   // private route: ActivatedRoute
  // ) { }

  @Input() data: any;
  isOldHide: boolean = true;
  isHide: boolean = true;
  isConfirmHide: boolean = true;
  form: FormGroup;
  isPasswordMatch: boolean = true;
  message = '';
  daysExpiration = localStorage.getItem('days_before_password_expiry');

  constructor(
    private _formBuilder: FormBuilder,
    public cdRef: ChangeDetectorRef,
    private _commonService: CommonService,
    private _snackBar: MatSnackBar,
    private _authService: AuthService,
    private _router: Router
  ) {}

  ngOnInit() {
    console.log(this.daysExpiration);
    this.form = this._formBuilder.group({
      oldPassword: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
      confirmPassword: new FormControl('', [Validators.required]),
    });
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  onSkip(): void {
    // this.dialogRef.close();
    this._router.navigate([HOME_PATH]);
  }

  onStrengthChanged(strength: number) {
    // console.log('password strength = ', strength);
    // if(strength >= 100) {
    //   this.form.get('password').setErrors({valid:true});
    // }
  }

  onPasswordConfirm(data) {
    var password = this.form.value.password;
    var confirmData = this.form.get('confirmPassword').value;
    if (password === confirmData) {
      this.isPasswordMatch = true;
      console.log('match');
      this.form.get('confirmPassword').setErrors(null);
    } else {
      this.isPasswordMatch = false;
      console.log('not not');
      this.form.get('confirmPassword').setErrors({ valid: false });
    }
    // isPasswordMatch
  }

  onSave() {
    // var isMatch = this.onPasswordConfirm(this.form.get('confirmPassword').value);
    if (this.form.valid) {
      let bodyData = {
        userName: localStorage.getItem('username'),
        oldPassword: this.form.get('oldPassword').value,
        newPassword: this.form.get('password').value,
      };
      // console.log(bodyData);
      this._snackBar.dismiss();

      let urlAction = 'users/v2/changePassword';
      this._commonService.commonPostAction(urlAction, bodyData).subscribe(
        resp => {
          let isExist = resp.response.includes('does not match');
          if (!isExist) {
            // this.form.reset();
            setTimeout(() => {
              // this.onCloseModal();
              // this._commonService.logout()
              this._router.navigate([HOME_PATH]);
            }, 200);
          } else {
            this._snackBar.open(resp.response, null, {
              duration: 5000,
              panelClass: 'custom-snack-bar-panel-error',
            });
          }
        },
        error => {
          console.log(error);
          this._snackBar.open(error.error.errorMessage, null, {
            duration: 5000,
            panelClass: 'custom-snack-bar-panel-error',
          });
        }
      );
    }
  }

  openWindow() {
    this._router.navigate(['/account/home']);
    let newwin = window.open(
      'account/vehicle-management/device-monitor/2',
      'device-monitor',
      'height=' + screen.height + ', width=' + screen.width + ' '
    );
    if (window.focus) {
      newwin.focus();
    }
    return false;
  }
}
